"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseISODuration = void 0;
const ISO_PERIOD = new RegExp('^([+-])?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?' +
    '(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$');
/**
 * @summary Parses an ISO8601 duration into a date-fns duration object.
 *
 * Parses an ISO8601 duration string into a date-fns duration object. Whitespace at the beginning and
 * end is ignored. If the duration string does not contain a compatible duration, a `TypeError` is thrown.
 *
 * `null` and `undefined` are interpreted as a zero duration.
 *
 * @param {string | undefined} duration
 * @return {Duration | undefined}
 * @throws {TypeError}
 *
 * @see https://github.com/date-fns/date-fns/issues/284#issuecomment-426231461
 *
 * @example
 * const duration = parseISODuration(timeSpan);
 */
function parseISODuration(duration) {
    if (duration == null) {
        return {};
    }
    const matches = ISO_PERIOD.exec(duration.trim());
    if (matches == null) {
        throw new TypeError(`Invalid ISO duration: ${duration}.`);
    }
    const neg = matches[1] === '-';
    const result = {};
    const keys = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const match = matches[i + 2];
        if (match != null && +match !== 0) {
            result[key] = neg ? -match : +match;
        }
    }
    return result;
}
exports.parseISODuration = parseISODuration;
